module.exports = __webpack_public_path__ + "static/img/IS@2x.2d68d890.jpg";